import EConsentContext from '@/contexts/EConsentContext';
import { FC, useContext } from 'react';
import MainConsentEConsentForm from './main-consent/MainConsentEConsentForm';
import MainConsentStandardForm from './main-consent/MainConsentStandardForm';

const MainConsentForm: FC = () => {
    const { userType } = useContext(EConsentContext);

    return userType
        ? <MainConsentEConsentForm />
        : <MainConsentStandardForm />;
};

export default MainConsentForm;
